/*
 * Copyright (c) Siemens AG 2018 ALL RIGHTS RESERVED.
 *
 * Digital Lifecycle Service (DLS)
 */

import React from 'react';
import FsmTable from './FSM/FsmTable';
import { icmaEnv } from '../../../utils/common';

const FSM_TABLE = 'FsmTable';
export default class ContentComponent extends React.Component {
  /**
   * Everytime the component will be updated, the script part of the loaded
   * html page will be executed. At creation time there is only a static text
   * so the execution will only happen with real html data which will always
   * be an update of the component.
   */
  componentDidUpdate(prevProps) {
    if (prevProps.selectedUrl !== this.props.selectedUrl) {
      this.executeScript();
    }
  }

  renderCustomComponent(componentName) {
    switch (componentName) {
      case FSM_TABLE:
        return <FsmTable settings={this.props.settings}/>
      default:
        return null;
    }
  }

  /**
   * Execute script after loading third party html
   */
  executeScript() {
    if (
      this.props.content.__html &&
      document
        .getElementById('dls-ap-content')
        .getElementsByTagName('script')[0]
    ) {
      const script = document
        .getElementById('dls-ap-content')
        .getElementsByTagName('script')[0].innerHTML;

      window.eval(script);
    }
  }

  render() {
    const isDE = localStorage.getItem('icmalanguage') === 'de';
    return (
      <div>
        {this.props.showNewAppBanner && (
          <div style={{ background: '#CFF4FC', padding: '10px 16px 10px 16px', marginBottom: '-30px', marginTop: '10px', fontSize: '18px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <i className="bi bi-info-circle-fill" style={{ marginRight: '10px', fontSize: '25px', color: 'rgb(13, 110, 253)' }}></i>
              <span>
                {isDE
                  ? 'Diese Funktion ist jetzt in der neu gestalteten ICMA-App verfügbar – mit verbesserter Leistung und stets aktuellen Daten.'
                  : 'This feature is now available in the redesigned ICMA App, offering improved performance and the most up-to-date data.'}
              </span>
            </div>
            <span
              onClick={() => {
                const env = icmaEnv(this.props.settings.server);
                const subdomain = env === 'DEV' ? 'app.icma-dev' : env === 'QA' ? 'app.icma-qa' : 'app.icma';
                window.open(`https://${subdomain}.siemens-energy.cloud/settings/ap/iacc-sc/ao?ppid=${this.props.ppid}`, '_blank');
              }}
              style={{ display: 'block', marginLeft: '35px', color: '#0d6efd', cursor: 'pointer', textDecoration: 'underline', fontSize: '18px', lineHeight: '1' }}
            >
              {isDE ? 'Zur neuen ICMA-App' : 'Go to New ICMA App'}
            </span>
          </div>
        )}
        {this.props.menuDesc && (
          <div id="dls-ap-description" className="dls-ap-decription-top">
            {this.props.menuDesc}
          </div>
        )}
        {
          this.props.component ? (
            this.renderCustomComponent(this.props.component)
          ) : <div
            id="dls-ap-content"
            className="dls-ap-padding-top"
            dangerouslySetInnerHTML={this.props.content}
          />
        }
      </div>
    );
  }
}
